import axios from 'axios';
import authService from './authService';
import { toast } from 'react-toastify';

const API_URL = 'https://huongtramcomoc.vn/api/admin';

const privateApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});
privateApi.interceptors.request.use(config => {
  const token = authService.getAdminToken();
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
});
privateApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      toast.warn("Phiên đăng nhập hết hạn hoặc không có quyền truy cập.");
      authService.logoutAdmin(); 
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);
// --- Định nghĩa các hàm ---

const getOrders = (filterType = 'all', filterValue = '') => {
  let url = 'get_orders.php';
  if (filterType !== 'all' && filterValue) {
    url += `?filter_type=${filterType}&filter_value=${filterValue}`;
  }
  return privateApi.get(url);
};

const getAdminProducts = () => {
  return privateApi.get('get_all_products.php');
};

const deleteProduct = (id) => {
  return privateApi.post('delete_product.php', { id: id });
};

const getCategories = () => {
  return axios.get('https://huongtramcomoc.vn/api/admin/categories_crud.php');
};

const createCategory = (data) => {
  return privateApi.post('categories_crud.php', data);
};

const updateCategory = (data) => {
  return privateApi.put('categories_crud.php', data);
};

const deleteCategory = (id) => {
  return privateApi.delete('categories_crud.php', { data: { id } });
};

// --- QUẢN LÝ MEDIA ---
const getMedia = (folderId = 1, page = 1) => {
  const cacheBuster = `&_=${new Date().getTime()}`;
  return privateApi.get(`media_get.php?folder_id=${folderId}&page=${page}${cacheBuster}`);
};

const uploadMedia = (folderId, formData) => {
  return privateApi.post('media_upload.php', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const createMediaFolder = (name, parentId) => {
  return privateApi.post('media_create_folder.php', {
    name: name,
    parent_id: parentId,
  });
};

const updateMediaFolder = (id, newName) => {
  return privateApi.post('media_edit_folder.php', {
    id: id,
    new_name: newName
  });
};

const moveMediaItem = (id, type, targetFolderId) => {
  return privateApi.post('media_move_item.php', {
    id: id,
    type: type,
    target_folder_id: targetFolderId
  });
};

const updateMediaFile = (id, name, altText) => {
  return privateApi.put('media_update_file.php', {
    id: id,
    name: name,
    alt_text: altText,
  });
};

const deleteMediaFile = (id) => {
  return privateApi.post('media_delete.php', {
    id: id,
    type: 'file',
  });
};

const deleteMediaFolder = (id) => {
  return privateApi.post('media_delete.php', {
    id: id,
    type: 'folder',
  });
};
// ---------------------

const linkImageToProduct = (productId, mediaFileId) => {
  return privateApi.post(`product_images_crud.php?action=link`, {
    product_id: productId,
    media_file_id: mediaFileId,
  });
};

const unlinkImageFromProduct = (productId, mediaFileId) => {
  return privateApi.post(`product_images_crud.php?action=unlink`, {
    product_id: productId,
    media_file_id: mediaFileId,
  });
};

const setProductThumbnail = (productId, mediaFileId) => {
  return privateApi.post(`product_images_crud.php?action=set_thumbnail`, {
    product_id: productId,
    media_file_id: mediaFileId,
  });
};

const createProduct = (productData) => {
  return privateApi.post('product_crud.php', productData);
};

const updateProduct = (productId, productData) => {
  const data = { ...productData, id: productId };
  return privateApi.put('product_crud.php', data); 
};

const getOrderDetails = (id) => {
  return privateApi.get(`get_order_details.php?id=${id}`);
};

const updateOrderStatus = (orderId, status) => {
  return privateApi.post('order_update_status.php', {
    order_id: orderId,
    status: status
  });
};

const updateStockQuick = (id, newQuantity) => {
  return privateApi.post('update_stock_quick.php', {
    id: id,
    stock_quantity: newQuantity
  });
};

const updatePageContent = (slug, title, content, featured_image_url = null) => {
  return privateApi.post('update_page_content.php', {
    slug, title, content, featured_image_url
  });
};

const deleteOrder = (id) => {
  return privateApi.post('order_delete.php', { id: id });
};

const getRevenueStats = (type) => {
  return privateApi.get(`get_revenue_stats.php?type=${type}`);
};

const getCoupons = () => {
  return privateApi.get('coupons_api.php');
};

const createCoupon = (data) => {
  return privateApi.post('coupons_api.php', data);
};

const updateCoupon = (data) => {
  return privateApi.put('coupons_api.php', data);
};

const deleteCoupon = (id) => {
  return privateApi.delete(`coupons_api.php?id=${id}`);
};

// --- QUẢN LÝ BANNER ---
const getBanners = () => {
  return privateApi.get('banner_crud.php');
};

const createBanner = (data) => {
  return privateApi.post('banner_crud.php', data);
};

const updateBanner = (data) => {
  return privateApi.put('banner_crud.php', data);
};

const deleteBanner = (id) => {
  return privateApi.delete(`banner_crud.php?id=${id}`);
};

// --- QUẢN LÝ FAQ ---
const getFaqs = () => {
  return privateApi.get('faq_crud.php');
};

const createFaq = (data) => {
  return privateApi.post('faq_crud.php', data);
};

const updateFaq = (data) => {
  return privateApi.put('faq_crud.php', data);
};

const deleteFaq = (id) => {
  return privateApi.delete(`faq_crud.php?id=${id}`);
};

// GÓI GỌN EXPORT
const adminService = {
  getOrders,
  getAdminProducts,
  deleteProduct,
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  getMedia,
  uploadMedia,
  createMediaFolder,
  updateMediaFolder,
  moveMediaItem,
  linkImageToProduct,
  unlinkImageFromProduct,
  setProductThumbnail,
  createProduct,
  updateProduct,
  updateMediaFile,
  deleteMediaFile,
  deleteMediaFolder,
  getOrderDetails, 
  updateOrderStatus,
  updateStockQuick,
  updatePageContent,
  deleteOrder,
  getRevenueStats,
  getCoupons,
  createCoupon,
  updateCoupon,
  deleteCoupon,
  getBanners,
  createBanner,
  updateBanner,
  deleteBanner,
  getFaqs,
  createFaq,
  updateFaq,
  deleteFaq
};

export default adminService;